var render = function (_h,_vm) {var _c=_vm._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.props.isNavOpen)?_c('div',{staticClass:"nav-overlay absolute lg:hidden inset-0"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }